import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TelegramBotQuickStart from './TelegramBotQuickStart';
import TelegramBotTokenBlock from './TelegramBotTokenBlock';

const TelegramBot = () => {
    const { t } = useTranslation(['Settings']);

    return (
        <Row>
            <Col sm={12}>
                <div className="w-100 d-flex pt-1 justify-content-between align-items-start mb-3 mb-md-2">
                    <div className="pb-1">
                        <h4 className="p-0 m-0">{t('telegramBot.title')}</h4>
                        <small className="text-muted">{t('telegramBot.subtitle')}</small>
                    </div>
                </div>

                <TelegramBotQuickStart />
                <TelegramBotTokenBlock />
            </Col>
        </Row>
    );
};

export default TelegramBot;
